export enum FileDestinationEnum {
	User = 'User',
	Event = 'Event',
	PrototypeUser = 'PrototypeUser',
	PrototypeMarket = 'PrototypeMarket',
	PrototypeEvent = 'PrototypeEvent',
	PrototypeFeaturedImage = 'PrototypeFeaturedImage',
	PrototypeChat = 'PrototypeChat',
	PrototypeLobby = 'PrototypeLobby',
	Export = 'Export',
}

export const FileDestinationArray = Object.values(FileDestinationEnum);
